export interface IServerCatalogRanges {
  acne?: number[] | string | null;
  wrinkles?: number[] | string | null;
  redness?: number[] | string | null;
  eyebag?: number[] | string | null;
  darkcircle?: number[] | string | null;
  darkCircle?: number[] | string | null;
  oiliness?: number[] | string | null;
}

export interface IServerCatalogItem {
  id?: string;
  itemNumber?: string;
  brandName?: string;
  name?: string;
  productName?: string;
  description?: string;
  productDescription?: string;
  routine?: string[] | string;
  routineInformation?: string[] | string;
  categories?: string[] | string;
  photoUrl?: string;
  productPhotoLink?: string;
  linkUrl?: string;
  productLink?: string;
  addToCartCode?: string;
  productAddToCartCode?: string;
  weight?: number | string | null;
  price?: number | string | null;
  recommendationWeight?: number | string | null;
  categoryRanges?: IServerCatalogRanges;
  acne?: string;
  wrinkles?: string;
  redness?: string;
  eyebag?: string;
  darkcircle?: string;
  darkCircle?: string;
  oiliness?: string;
  questionAnswerIds?: Record<string, Array<number | string>> | null;
}

export interface ICatalogRow {
  itemNumber: string;
  brandName: string;
  productName: string;
  productDescription: string;
  routineInformation: string;
  productPhotoLink: string;
  productLink: string;
  categories: string;
  productAddToCartCode: string;
  weight: string;
  price: string;
  acne: string;
  wrinkles: string;
  redness: string;
  eyebag: string;
  darkCircle: string;
  oiliness: string;
  answersByQuestionId: { [questionId: string]: string[] };
}

export interface ICatalogHeaderMap {
  itemNumber: string;
  brandName: string;
  productName: string;
  productDescription: string;
  routineInformation: string;
  productPhotoLink: string;
  productLink: string;
  categories: string;
  productAddToCartCode: string;
  weight: string;
  price: string;
  acne: string;
  wrinkles: string;
  redness: string;
  eyebag: string;
  darkCircle: string;
  oiliness: string;
}

export type CatalogMode = 'upload' | 'manual';

export interface ICatalogDraftState {
  mode: CatalogMode;
  companyId: string | null;
  searchProductName: string;
  manualRows: ICatalogRow[];
  importedRows: ICatalogRow[];
  paginaSelecionada: number;
  tamanhoPagina: number;
  isCatalogLoadedFromServer: boolean;
  loadedCatalogCompanyId: string | null;
  catalogLoadMessage: string;
}

export interface ISkincareThresholdSettings {
  companyId: string | null;
  veryBadMax: number | null;
  needProcessingMax: number | null;
  canImproveMax: number | null;
  veryGoodMax: number | null;
  isCustom: boolean;
}

export interface IUpsertSkincareThresholdSettingsInput {
  veryBadMax: number;
  needProcessingMax: number;
  canImproveMax: number;
  veryGoodMax: number;
}

export const EMPTY_SKINCARE_THRESHOLD_SETTINGS: ISkincareThresholdSettings = {
  companyId: null,
  veryBadMax: null,
  needProcessingMax: null,
  canImproveMax: null,
  veryGoodMax: null,
  isCustom: false
};
